/**
 * electric auth logout
 *
 * Clears stored credentials.
 */

import { Command } from 'commander'
import { clearStoredAuth } from '../../config.js'
import { handleError } from '../../lib/errors.js'
import { printSuccess, printJson } from '../../output.js'

export const logoutCommand = new Command(`logout`)
  .description(`Log out and clear stored credentials`)
  .action(async () => {
    const json = logoutCommand.parent?.parent?.opts().json ?? false
    try {
      await clearStoredAuth()
      if (json) {
        printJson({ success: true })
      } else {
        printSuccess(`Logged out successfully.`)
      }
    } catch (error) {
      handleError(error, json)
    }
  })
